/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const prescriptionPrintSettings = sqliteTable('prescription_print_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  template_id: text('template_id'),
  logo_source: text('logo_source'),
  clinic_name: text('clinic_name'),
  clinic_address: text('clinic_address'),
  clinic_phone: text('clinic_phone'),
  clinic_email: text('clinic_email'),
  clinic_website: text('clinic_website'),
  footer_text: text('footer_text'),
  show_patient_demographics: integer('show_patient_demographics'),
  show_complaint: integer('show_complaint'),
  show_vitals: integer('show_vitals'),
  show_item_details: integer('show_item_details'),
  show_instructions: integer('show_instructions'),
  show_doctor_footer: integer('show_doctor_footer'),
  show_signature_block: integer('show_signature_block'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
